<template>
    <div class="row">
        <div v-if="loading" class="col-12 mt-5 mb-5" v-loading="true"></div>
        <div v-else class="col-12">
            <card>
                <form class="form-horizontal">
                    <!-- NAME -->
                    <div class="row">
                        <label class="col-sm-2 col-form-label">Name *</label>
                        <div class="col-sm-10">
                            <div class="form-group">
                                <el-input v-model="speaker.name"/>
                            </div>
                        </div>
                    </div>
                    <!-- LAST NAME -->
                    <div class="row">
                        <label class="col-sm-2 col-form-label">Last Name *</label>
                        <div class="col-sm-10">
                            <div class="form-group">
                                <el-input v-model="speaker.lastName"/>
                            </div>
                        </div>
                    </div>
                    <!-- COMPANY -->
                    <div class="row">
                        <label class="col-sm-2 col-form-label">Company</label>
                        <div class="col-sm-10">
                            <div class="form-group">
                                <el-input v-model="speaker.company"/>
                            </div>
                        </div>
                    </div>
                    <!-- POSITION -->
                    <div class="row">
                        <label class="col-sm-2 col-form-label">Position</label>
                        <div class="col-sm-10">
                            <div class="form-group">
                                <el-input v-model="speaker.position"/>
                            </div>
                        </div>
                    </div>
                    <!-- PICTURE -->
                    <div class="row">
                        <label class="col-sm-2 col-form-label">Picture</label>
                        <div class="col-sm-10">
                            <div class="form-group">
                                <input
                                    type="file"
                                    id="picture-upload"
                                    @change="uploadPicture"/>
                                <label for="logo-upload">
                                    <el-button>Choose File</el-button>
                                </label>
                                <div v-if="pictureProgress !== 100">
                                    <el-progress :percentage="pictureProgress"/>
                                </div>
                                <div
                                    v-else-if="speaker.picture && speaker.picture._id"
                                    class="form-text">
                                        <img
                                            :src="$store.state.baseUrl + speaker.picture.path"
                                            width="100px"/>
                                </div>
                                <div
                                    v-else
                                    class="form-text">
                                        Upload a picture to identify your speaker.
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- E-MAIL -->
                    <div class="row">
                        <label class="col-sm-2 col-form-label">E-Mail</label>
                        <div class="col-sm-10">
                            <div class="form-group">
                                <el-input v-model="speaker.email"/>
                            </div>
                        </div>
                    </div>
                    <!-- BIOGRAPHY -->
                    <div class="row">
                        <label class="col-sm-2 col-form-label">Biography</label>
                        <div class="col-sm-10">
                            <div class="form-group">
                                <quill-editor v-model="speaker.biography"/>
                            </div>
                        </div>
                    </div>
                    <!-- TWITTER -->
                    <div class="row">
                        <label class="col-sm-2 col-form-label">Twitter</label>
                        <div class="col-sm-10">
                            <div class="form-group">
                                <el-input v-model="speaker.twitter">
                                    <template slot="prepend">@</template>
                                </el-input>
                            </div>
                        </div>
                    </div>
                    <!-- LINKEDIN -->
                    <div class="row">
                        <label class="col-sm-2 col-form-label">Linkedin</label>
                        <div class="col-sm-10">
                            <div class="form-group">
                                <el-input v-model="speaker.linkedin">
                                    <template slot="prepend">url:</template>
                                </el-input>
                            </div>
                        </div>
                    </div>
                </form>
                <template slot="footer">
                    <div class="d-flex justify-content-end">
                        <el-button
                            @click="submit()"
                            :loading="saving"
                            type="primary"
                            class="btn btn-primary">
                                Save
                        </el-button>
                    </div>
                </template>
            </card>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            speaker: {
                eventId: this.$route.params.eventId,
                name: '',
                lastName: '',
                company: '',
                position: '',
                email: '',
                biography: '',
                twitter: '',
                linkedin: '',
                picture: null
            },
            saving: false,
            loading: false,
            pictureProgress: 100,
            pictureInterval: null
        }
    },
    mounted () {
        if (this.$route.params.speakerId) {
            this.getSpeaker()
        }
    },
    methods: {
        submit: async function () {
            try {
                this.saving = true
                if (this.$route.params.speakerId) {
                    await this.$store.dispatch('update', {
                        path: 'speakers',
                        data: this.speaker,
                        id: this.$route.params.speakerId
                    })

                    this.$notify('Information successfully updated!')
                } else {
                    await this.$store.dispatch('create', { path: 'speakers', data: this.speaker })
                    this.$notify('Speaker was successfully created!')
                    this.$router.push({ name: 'settings' })
                }
            } catch (e) {
                console.log('error creating new speaker')
            }
            this.saving = false
        },
        getSpeaker: async function () {
            try {
                this.loading = true
                const response = await this.$store.dispatch('get', { path: 'speakers', key: 'speaker', id: this.$route.params.speakerId })
                this.speaker = response.data.speaker
            } catch (e) {
                console.log('error getting speaker')
            }

            this.loading = false
        },
        uploadPicture: async function (event) {
            this.pictureProgress = 1
            this.pictureInterval = setInterval(() => {
                if (this.pictureProgress < 98) {
                    this.pictureProgress += 1
                } else {
                    clearInterval(this.pictureInterval)
                    this.pictureInterval = null
                }
            }, 100)

            try {
                const response = await this.$store.dispatch('uploadFIle', event.target.files[0])
                this.speaker.picture = response.data.file
            } catch (e) {
                console.log('error uploading speaker picture')
            }

            clearInterval(this.pictureInterval)
            this.pictureInterval = null
            this.pictureProgress = 100
        },
    }
}
</script>
